import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit, signal, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, DatePipe } from '@angular/common';
import { DeepackListResponse, DeepackPopupInput, DepackFeedstockLoadScheduleByIdResponse, DepackFeedstockLoadScheduleWithStreamsByIdResponse, DepackStreamGridResponse, LoadSchedulePopupInput, SaveDepackFeedstockLoadScheduleRequest, SaveDepackFSLSAdditionalStreamsRequest, SaveFeedStockLoadSchedule_AdditionalStreamsRequest, SaveFeedstockLoadScheduleRequest } from '../../../interfaces/feedstocklistmodel';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ErrorStateMatcher, provideNativeDateAdapter } from '@angular/material/core';
import { LookUpService } from '../../../services/lookupservice';
import { Regions, SitesShortForm, SiteTanksResponse } from '../../../interfaces/regions';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { StreamsList } from '../../../interfaces/streamsmodel';
import { FeedstockService } from '../../../services/feedstockservice';
import { GeneratorsList } from '../../../interfaces/generatorsmodel';
import { FeedstockStatus, GetDisposalMethodsBySiteIdResponse } from '../../../interfaces/feedstockstatus';
import { MaterialUnitOfMeasureLookupResponse, ORHaulerResponse } from '../../../interfaces/haulerModel';
import { FeedStockSchedulePriceMatrixRequest, IdName } from '../../../interfaces/pricematrixmodel';
import { CancelReasonResponse, FeeCategoryLookupResponse, TruckTypesResponse } from '../../../interfaces/feeCategoryLookupResponse';
import { MatMenuModule } from '@angular/material/menu';
import { AlertDialogComponent } from '../../shared/components/alert-dialog/alert-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmationDialogData, ConfirmationDialogComponent } from '../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { first, forkJoin, tap } from 'rxjs';
import { SaveAttemptErrorMatcher } from '../../shared/commonutils/errorStateDirective';
import { RoleService } from '../../../services/role.service';
import { formatDateOnly } from '../../shared/commonutils/helper';
import { DepackService } from '../../../services/depack.service';
import { AttachDocumentsComponent } from '../attach-documents/attach-documents.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSelectItems } from '../../../interfaces/lookup';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SelectSearchComponent } from '../../shared/components/select-search/select-search.component';
import { StreamsGridComponent } from '../streams-grid/streams-grid.component';
import { PriceMatrixService } from '../../../services/pricematrix.service';

@Component({
  selector: 'app-addedit-deepack',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatTableModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatDialogModule,
    DragDropModule,
    SelectSearchComponent,
    StreamsGridComponent,
    MatSlideToggleModule
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './addedit-deepack.component.html',
  styleUrl: './addedit-deepack.component.scss'
})

export class AddeditDeepackComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  feeCategories: IdName[] = [];
  hid: string | null = null;
  haulerId: number | null = null;
  haulers: ORHaulerResponse[] = [];
  marketId: string = "-1";
  generatorId: number | null = null;
  siteId: number = -1;
  sid: string | null = null;
  selectSiteItems: MatSelectItems[] = [];
  selectCustomerItems: MatSelectItems[] = [];
  selectCustomerLocationItems: MatSelectItems[] = [];
  selectHaulerItems: MatSelectItems[] = [];
  selectStatusItems: MatSelectItems[] = [];
  generators: IdName[] = [];
  customerLocations: IdName[] = [];
  sites: SitesShortForm[] = [];
  fsStatuses: FeedstockStatus[] = [];
  mode: string = "";
  fsStatusId: number = 0;
  locName: string | null = null;
  fsLoadId: number = 0;
  selectedFeeCategories: number[] = [];
  workOrderNumber: string = '';
  actualDate: string = '';
  loadPMDetails: any;
  loadStreams: DepackStreamGridResponse[] = [];
  selectedFeeCategoryRows: { name: string; value: number }[] = [];
  gridTotal = 0;
  rebateReduction = 0;
  feeCategoryTotal = 0;
  finalTotal = 0;
  // Form Builder
  upsertDepackForm!: FormGroup;
  attemptSave = signal(false);
  public matcher = new SaveAttemptErrorMatcher(() => this.attemptSave());
  @ViewChild(StreamsGridComponent) streamGridComp!: StreamsGridComponent;
  prevFeeCategoryIds: number[] = [];
  private readonly FEE_LTL = 7;
  private readonly FEE_FTL = 8;
  private readonly ZERO_VOLUME = 6;

  constructor(
    private fsService: FeedstockService,
    private depackService: DepackService,
    private lookUp: LookUpService,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private pmService: PriceMatrixService, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public inputData: DeepackPopupInput,
    public dialogRef: MatDialogRef<AddeditDeepackComponent>) {

    console.log("incoming data", inputData);
    this.initializeForm();

    const initialDate = this.upsertDepackForm.get('actualDate')?.value;
    this.actualDate = this.datePipe.transform(initialDate, 'MM/dd/yyyy') ?? '';

    this.upsertDepackForm.get('zeroVolumeFee')?.valueChanges.subscribe(() => {
      this.calculateTotals();
    });
    this.upsertDepackForm!.get('actualDate')?.valueChanges.subscribe(date => {
      if (date) {
        const dateString = this.datePipe.transform(date, 'MM/dd/yyyy');
        if (dateString)
          this.actualDate = dateString;
        console.log(dateString); // "05/06/2026"
      }
    });
  }

  ngOnInit(): void {
    this.mode = this.inputData.mode;
    this.fsLoadId = this.inputData.fsLoadId;

    this.loadDropdows();
    this.getHeaderText();
  }

  initializeForm(): void {
    this.upsertDepackForm = this.fb.group({
      id: [0],
      actualDate: [new Date(), Validators.required],
      priceMatrixId: [null],
      generatorId: [null, Validators.required],
      sid: [null, Validators.required],
      hid: [null, Validators.required],
      fsStatusId: [9, Validators.required],
      truckNumber: [null],
      trailerNumber: [null],
      driverName: [null],
      bol: [null],
      seal: [null],
      customerPO: [null],
      pickUp: [null],
      release: [null],
      notesForCustomer: [null, Validators.maxLength(500)],
      notesForHauler: [null, Validators.maxLength(500)],
      internalNotes: [null, Validators.maxLength(500)],
      isInvoiceThisLoad: [null],
      holdLoadOnComplete: [null],
      freightCharge: [{ value: 0, disabled: true }],
      zeroVolumeFee: [{ value: 0, disabled: true }],
      feeCategories: [[]],
      location: [null, Validators.required]
    });
  }

  loadDropdows() {
    forkJoin({
      sites: this.depackService.getDepackSites(),
      feeCategories: this.depackService.getDepackFeeCategories(),
      statues: this.fsService.getFeedStockStatuses(''),
      haulers: this.lookUp.getHaulers(this.marketId)
    })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({ sites, feeCategories, statues, haulers }) => {

        //Sites
        this.sites = sites;
        this.selectSiteItems = this.sites.map(item => ({
          id: item.id!,
          name: item.siteName!
        }));

        //Statues
        this.fsStatuses = statues;
        this.selectStatusItems = this.fsStatuses.map(item => ({
          id: item.id!,
          name: item.description!
        }));

        //categories
        this.feeCategories = feeCategories;

        //haulers
        this.haulers = haulers;
        this.selectHaulerItems = this.haulers.map(item => ({
          id: item.id!,
          name: item.name!
        }));

        if (this.mode !== 'Add') {
          this.getByIDAndPatchData();
        }
      });
  }

  //Get the Deepack customers based on the selected site
  getDepackCustomers(siteId: number) {
    this.depackService.getDepackCustomers(siteId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: IdName[]) => {
          this.generators = res;
          this.selectCustomerItems = this.generators.map(item => ({
            id: item.id!,
            name: item.name!
          }));
        }
      });
  }

  //Get the Deepack customer locations based on the selected customer
  getDepackCustomerLocations(customerId: number) {
    this.depackService.getCustomerLocations(customerId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: any[]) => {
          this.customerLocations = res;
          this.selectCustomerLocationItems = this.customerLocations.map(item => ({
            id: item.name!,
            name: item.name!
          }));
        }
      })
  }

  getByIDAndPatchData() {
    this.depackService.getDepackLoadById(this.fsLoadId)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (loadRecord: DepackFeedstockLoadScheduleWithStreamsByIdResponse) => {
          console.log("edit reocrd depack", loadRecord)
          this.upsertDepackForm.patchValue({
            id: this.mode === 'Edit' ? loadRecord.data.id : 0,
            priceMatrixId: loadRecord.data.priceMatrixId,
            actualDate: loadRecord.data.actualDate,
            generatorId: loadRecord.data.generatorId,
            fsStatusId: loadRecord.data.status,
            sid: loadRecord.data.sid,
            hid: loadRecord.data.hid,
            truckNumber: loadRecord.data.truck_Number,
            trailerNumber: loadRecord.data.trailer_Number,
            driverName: loadRecord.data.driver,
            bol: loadRecord.data.bol,
            seal: loadRecord.data.seal,
            customerPO: loadRecord.data.customerReferenceNo,
            pickUp: loadRecord.data.pickUp,
            release: loadRecord.data.release,
            notesForCustomer: loadRecord.data.notesForCustomer,
            notesForHauler: loadRecord.data.notesForHauler,
            internalNotes: loadRecord.data.internalNotes,
            isInvoiceThisLoad: loadRecord.data.isInvoiceReqForCancelledLoad,
            holdLoadOnComplete: loadRecord.data.holdLoadOnComplete,
            zeroVolumeFee: loadRecord.data.flatFee,
            feeCategories: this.toNumberArray(loadRecord.data.feeCategories),
            location: loadRecord.data.location
          });

          
          this.prevFeeCategoryIds = [...this.toNumberArray(loadRecord.data.feeCategories)];

          //Assign the values for drop down
          this.siteId = loadRecord.data.siteId;
          this.sid = loadRecord.data.sid;
          this.hid = loadRecord.data.hid;
          this.generatorId = loadRecord.data.generatorId;
          this.haulerId = loadRecord.data.haulerId;
          this.fsStatusId = loadRecord.data.status;
          this.workOrderNumber = loadRecord.data.workOrderNumber
          this.locName = loadRecord.data.location;

          if (loadRecord.data.feeCategories) {
            this.selectedFeeCategories = this.toNumberArray(loadRecord.data.feeCategories);
          }
          this.loadStreams = (loadRecord.streams ?? []).map((x: any) => ({
            id: this.mode === 'Edit' ?  x.id ?? 0 : 0,
            fSLoadID: this.mode === 'Edit' ? x.fsLoadID ?? this.fsLoadId : 0,
            streamID: x.streamID,
            streamName: x.streamName ?? '',
            uom: x.uom,
            uomText: x.uomText ?? '',
            quantity: x.quantity,
            tipFee: loadRecord.data.tipFee ?? 0,
            aD_RebateUOM: x.aD_RebateUOM,
            aD_RebateUOMText: x.aD_RebateUOMText ?? '',
            aD_RebateQty: x.aD_RebateQty,
            rebateValue: x.rebateValue ?? null,
            haulRev: x.haul_Rate_Perload ?? 0,
            rebate_Total: (Number(x.aD_RebateQty ?? 0) * Number(x.rebateValue ?? 0)),
            rebateTotal: (Number(x.aD_RebateQty ?? 0) * Number(x.rebateValue ?? 0)),
            total: Number(((Number(x.quantity ?? 0) * Number(loadRecord.data.tipFee ?? 0)) - (Number(x.aD_RebateQty ?? 0) * Number(x.rebateValue ?? 0))).toFixed(4)),
            aPriceMatrixId: loadRecord.data.priceMatrixId ?? null
          }));

          const firstHaulRev = Number(this.loadStreams[0]?.haulRev ?? 0);
          console.log("data edit haul rev", firstHaulRev);
          this.upsertDepackForm.patchValue({
            freightCharge: firstHaulRev
          });

          this.getDepackCustomers(this.siteId);
          this.getDepackCustomerLocations(this.generatorId);

          if (this.selectedFeeCategories.length > 0) {
            this.onFeeCategoryChange(this.selectedFeeCategories);
          } else {
            this.selectedFeeCategoryRows = [];
            this.calculateTotals();
          }
        }
      });
  }

  toNumberArray(value: string): number[] {
    return value
      ? value.split(',').map(v => Number(v.trim()))
      : [];
  }

  getHeaderText(): string {
    if (this.mode === 'Add') {
      return 'Add Inbound Load';
    } else if (this.mode === 'Edit') {
      return 'Edit Inbound Load (' + this.workOrderNumber + ')';
    } else if (this.mode === 'Duplicate') {
      return 'Duplicate Inbound Load';
    } else {
      return '';
    }
  }

  //Event handlers for the dropdowns to capture the selected values 
  // for site, customer, hauler which are required for saving the Deepack load
  onHaulerReceived(event: number | null) {
    this.haulerId = event;
    this.hid = "MH-".concat(event!.toString());
  }

  onCustomerReceived(event: number | null) {
    this.generatorId = event;
    this.getDepackCustomerLocations(this.generatorId!);
  }

  onCustomerLocationReceived(event: any) {
    this.locName = event.toString();
  }

  onSiteReceived(event: number | null) {
    this.siteId = event!;
    this.sid = "VRS-".concat(event!.toString());
    this.getDepackCustomers(this.siteId);
  }

  onStatusReceived(event: number | null) {
    this.fsStatusId = event!;
  }

  onKeydown(event: KeyboardEvent) {
    if (event.ctrlKey && event.metaKey) { return; }
    if (!/[0-9\/]/.test(event.key) && event.key.length === 1) {
      event.preventDefault();
    }
  }
  
  dateformat(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    if (!value) return;
    const parts = value.split('/');
    if (parts.length !== 3) return;

    let [month, day, year] = parts.map(part => part.padStart(2, '0'));
    if (month.length === 1) month = '0' + month;
    if (day.length === 1) day = '0' + day;
    if (year.length === 2) year = '20' + year;
    input.value = `${month}/${day}/${year}`;
  }

  onStreamAddedOrUpdated(streams: DepackStreamGridResponse[]) {
    //Need to refresh the grid
    this.loadStreams = (streams ?? []).filter(x => !!x);
    const firstHaulRev = Number(this.loadStreams[0]?.haulRev ?? 0);

    this.upsertDepackForm.patchValue({
      freightCharge: firstHaulRev
    });

    this.calculateTotals();
  }

  //Cancel dialog
  onCancel(): void {
    this.dialogRef.close(false);
  }

  onSave() {
    this.attemptSave.set(true);
    this.upsertDepackForm.markAsDirty();
    this.upsertDepackForm.markAllAsTouched();
    if (this.upsertDepackForm.invalid) {
      return;
    }

    const raw = this.upsertDepackForm.getRawValue();
    console.log("inbound data to save", raw);
    if (!this.loadStreams || this.loadStreams.length === 0) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: `Add atleast one additional stream.`
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }

    const payload: SaveDepackFeedstockLoadScheduleRequest = {
      id: this.mode === 'Edit' ? raw.id ?? 0 : 0,
      siteID: this.sid,
      actualDate: raw.actualDate,
      generatorId: raw.generatorId?.toString() ?? null,
      hauler: this.hid,
      driver: raw.driverName,
      trailer_Number: raw.trailerNumber,
      status: raw.fsStatusId,
      notesForHauler: raw.notesForHauler,
      notesForCustomer: raw.notesForCustomer,
      internalNotes: raw.internalNotes,
      flatFee: Number(raw.zeroVolumeFee ?? 0),
      feeCategories: Array.isArray(raw.feeCategories)
        ? raw.feeCategories.join(',')
        : raw.feeCategories?.toString() ?? null,
      customerReferenceNo: raw.customerPO,
      holdLoadOnComplete: raw.holdLoadOnComplete,
      isInvoiceReqForCancelledLoad: raw.isInvoiceThisLoad,
      seal: raw.seal,
      bol: raw.bol,
      truck_Number: raw.truckNumber,
      pickUp: raw.pickUp,
      release: raw.release,
      fS_LoadSchedule_AdditionalStreams: this.loadStreams.map((x): SaveDepackFSLSAdditionalStreamsRequest => ({
        id: this.mode === 'Edit' ? x.id ?? 0 : 0,
        fSLoadID: this.fsLoadId ?? 0,
        streamID: x.streamID,
        uOM: x.uom,
        quantity: x.quantity,
        tipFee: x.tipFee,
        aD_RebateUOM: x.aD_RebateUOM,
        rebateValue: x.rebateValue,
        aD_RebateQty: x.aD_RebateQty,
        aD_RebateUOMText: '',
        priceMatrixId: x.aPriceMatrixId,
        streamName: '',
        uOMText: ''
      })
      ),
      documents: null
    };

    const formDataPayload = new FormData();

    const appendFormData = (formData: FormData, data: any, parentKey?: string) => {

      if (data === null || data === undefined) {
        return;
      }

      // ===== Date =====
      if (data instanceof Date) {
        formData.append(
          parentKey!,
          this.datePipe.transform(data, 'yyyy-MM-dd')!
        );
        return;
      }

      // ===== File =====
      if (data instanceof File) {
        formData.append(parentKey!, data);
        return;
      }

      // ===== Array =====
      if (Array.isArray(data)) {

        data.forEach((item, index) => {

          appendFormData(
            formData,
            item,
            `${parentKey}[${index}]`
          );

        });

        return;
      }

      // ===== Object =====
      if (typeof data === 'object') {

        Object.keys(data).forEach(key => {

          appendFormData(
            formData,
            data[key],
            parentKey ? `${parentKey}.${key}` : key
          );

        });

        return;
      }

      // ===== Primitive =====
      formData.append(parentKey!, String(data));
    };

    appendFormData(formDataPayload, payload);

    // ===== ✅ Append Documents =====
    const storedDocs: any[] =
      JSON.parse(localStorage.getItem('documents') || '[]');

    storedDocs.forEach(doc => {

      formDataPayload.append('Documents.screenTypeId', '5');
      formDataPayload.append('Documents.docTypeId', doc.docTypeId.toString());

      doc.files.forEach((f: any) => {
        const file = this.base64ToFile(f.data, f.name, f.type);
        const safeName = f.name.replace(/[&#]/g, '_');

        formDataPayload.append('Documents.files', file, safeName);
      });

    }); // close storedDocs.forEach
    
    this.depackService.saveDepackLoad(formDataPayload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          this.dialogRef.close(true);
        }
      });

  } // close onSave()

  getFeeCategoryValues(generatorId: number, steamId: number, sid: string, hid: string, actualDate: string) {
    this.pmService.getFeeCategoryValues(generatorId, steamId, sid, hid, actualDate).subscribe({
      next: async (response: any) => {
        this.loadPMDetails = response;
      }
    })
  }

  streamsUpsertEvent(event: any) {
    //If we have the streams call the first stream PM details
    if (event && event.length > 0) {
      var streamRecord = event[0];
      this.getFeeCategoryValues(this.generatorId!, streamRecord.streamID, this.sid!, this.hid!, this.actualDate)
    }
  }

  onFeeCategoryChange(selectedIds: number[], manualChange: boolean = false) {
    this.selectedFeeCategoryRows = this.feeCategories
      .filter(x => selectedIds.includes(x.id))
      .map(x => ({
        name: x.name,
        value: Number((x as any).value ?? 0)
      }));

    const hasLTL = selectedIds.includes(this.FEE_LTL);
    const hasFTL = selectedIds.includes(this.FEE_FTL);

    if (hasLTL && hasFTL) {
      const justAddedFTL = !this.prevFeeCategoryIds.includes(this.FEE_FTL) && hasFTL;

      const revertedIds  = justAddedFTL
          ? selectedIds.filter(id => id !== this.FEE_FTL)  // FTL just added → remove it
          : selectedIds.filter(id => id !== this.FEE_LTL); // LTL just added → remove it
      
      this.upsertDepackForm.get('feeCategories')?.setValue(revertedIds, { emitEvent: false });

      if(manualChange){
        this.dialog.open(AlertDialogComponent, {
          data: {
            title: 'Alert',
            message: 'You must select either Environment Fee LTL or Environment Fee FTL, not both.'
          },
          disableClose: true,
          panelClass: 'delete-confirmation-dialog-nowrap'
        });
      }
      this.onFeeCategoryChange(revertedIds, false)
      return;
    }

    if (!this.loadStreams || this.loadStreams.length === 0) {
      this.selectedFeeCategoryRows = [];
      this.calculateTotals();
      return;
    }
    
    this.prevFeeCategoryIds = [...selectedIds];
    const hasZeroVolume = selectedIds.includes(this.ZERO_VOLUME);
    const zeroVolumeFeeCtrl = this.upsertDepackForm.get('zeroVolumeFee');

    if (hasZeroVolume) {
      zeroVolumeFeeCtrl?.enable();
    } else {
      zeroVolumeFeeCtrl?.setValue(0);
      zeroVolumeFeeCtrl?.disable();
    }

    const firstStream = this.loadStreams[0];

    this.pmService.getFeeCategoryValues(this.generatorId!, firstStream.streamID, this.sid!, this.hid!,
      this.actualDate).subscribe({
        next: (response: any[]) => {
          this.selectedFeeCategoryRows = this.feeCategories
            .filter(fee => selectedIds.includes(fee.id))
            .map(fee => {
              const feeValue = response.find(x =>
                this.normalizeText(x.type) === this.normalizeText(fee.name)
              );
              return {
                name: fee.name,
                value: Number(feeValue?.amount ?? 0)
              };
            });

          this.calculateTotals();
        }
      });
  }

  private normalizeText(value: string | null | undefined): string {
    return (value ?? '').trim().toLowerCase();
  }

  calculateTotals() {
    this.gridTotal = Number(
      this.loadStreams.reduce(
        (sum, x) => sum + Number(x?.total ?? 0),
        0
      ).toFixed(4)
    );

    this.rebateReduction = Number(
      this.loadStreams.reduce(
        (sum, x) => sum + Number(x?.rebateTotal ?? 0),
        0
      ).toFixed(4)
    );

    this.feeCategoryTotal = Number(
      this.selectedFeeCategoryRows.reduce(
        (sum, x) => sum + Number(x?.value ?? 0),
        0
      ).toFixed(4)
    );


    const freightCharge = +(
      Number(this.upsertDepackForm.get('freightCharge')?.value ?? 0)
    ).toFixed(4);

    const zeroVolumeFee = +(
      Number(this.upsertDepackForm.get('zeroVolumeFee')?.value ?? 0)
    ).toFixed(4);

    this.finalTotal = Number(
      (
        this.gridTotal +
        freightCharge +
        zeroVolumeFee +
        this.feeCategoryTotal
      ).toFixed(4)
    );
  }
  private base64ToFile(base64: string, fileName: string, contentType: string): File {

    const byteCharacters = atob(base64.split(',')[1] || base64);

    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    return new File([byteArray], fileName, {
      type: contentType
    });
  }

  onAttachDocument(): void {

    const dialogRef = this.dialog.open(AttachDocumentsComponent, {
      width: '700px',
      panelClass: 'attachDocumentsDialog',
      disableClose: true,
      data: {
        loadScheduleId: this.fsLoadId,
        screenTypeId: '0',
        name: this.workOrderNumber,
        disableAddMoreFiles: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // optional refresh logic
      }
    });
  }

  onReset() {

  }

}
